import { jsx as _jsx } from "react/jsx-runtime";
import { makeStyles } from '@material-ui/core';
import { BowtieLogoSmall } from '../svg';
const useStyles = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'center',
    animation: '$blink 0.8s infinite'
  },
  '@keyframes blink': {
    '0%': {
      opacity: 1
    },
    '50%': {
      opacity: 0.2
    },
    '100%': {
      opacity: 1
    }
  }
});

const BowtieSpinner = () => {
  const classes = useStyles();
  return _jsx("div", {
    className: classes.root,
    children: _jsx(BowtieLogoSmall, {
      width: 90,
      height: 90
    })
  });
};

export default BowtieSpinner;